import React from 'react';
import { motion } from 'framer-motion';

const Gatekeeper = () => (
  <section className="relative py-36 overflow-hidden border-t border-wine/20">
    <div className="absolute inset-0 bg-darker" />
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(114,47,55,0.1)_0%,transparent_65%)]" />
    <div className="absolute top-0 left-0 right-0 h-[1px]"
      style={{ background: 'linear-gradient(to right, transparent, rgba(114,47,55,0.5), transparent)' }} />

    <div className="relative z-10 max-w-2xl mx-auto px-6 text-center">
      <motion.p
        initial={{ opacity: 0, letterSpacing: '0.1em' }}
        whileInView={{ opacity: 1, letterSpacing: '0.4em' }}
        viewport={{ once: true }}
        transition={{ duration: 1.5 }}
        className="text-wine-light uppercase text-xs font-semibold mb-12 tracking-[0.35em]"
      >
        Bevor du dich anmeldest
      </motion.p>

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9 }}
        className="text-4xl md:text-5xl font-serif text-cream leading-tight mb-12"
      >
        Diese Masterclass ist{' '}
        <span className="italic text-wine-light" style={{ textShadow: '0 0 20px rgba(155,66,78,0.4)' }}>
          nicht für jede Frau.
        </span>
      </motion.h2>

      <div className="space-y-8 text-lg text-cream/70 font-light leading-relaxed mb-14">
        {[
          { delay: 0.2, text: 'Sie ist nicht für Frauen, die nach einer schnellen Technik suchen, die ihnen sagt, wie sie ihn zurückbekommen. Sie ist nicht für Frauen, die ihren Business-Umsatz verdoppeln wollen, ohne sich selbst anzuschauen.' },
          { delay: 0.4, text: 'Sie ist nicht für Frauen, die in der Opferrolle verbleiben möchten und die Verantwortung für ihr Leben lieber bei anderen lassen. Wenn du das liest und dich provoziert fühlst – gut. Das bedeutet, du bist nah an deiner Wahrheit.' },
          { delay: 0.6, highlight: true, text: 'Diese Masterclass ist für die Frau, die bereit ist, die volle Verantwortung für ihre Energie, ihre Muster und ihr Leben zu übernehmen. Die bereit ist, sich anzuschauen – ohne Selbstverurteilung, aber mit absoluter Ehrlichkeit.' },
          { delay: 0.8, text: 'Wenn das du bist – dann ist dies deine Einladung. Nicht deine letzte Chance. Aber vielleicht der Beginn von allem.' },
        ].map((block, i) => (
          <motion.p key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: block.delay, duration: 0.8 }}
            className={block.highlight ? 'text-cream font-serif italic text-xl' : ''}
          >
            {block.text}
          </motion.p>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, scaleX: 0 }}
        whileInView={{ opacity: 1, scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.5 }}
        className="w-full h-[1px] mb-14 origin-center"
        style={{ background: 'linear-gradient(to right, transparent, rgba(114,47,55,0.5), transparent)' }}
      />

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.9 }}
        className="text-xs text-cream/30 tracking-widest uppercase"
      >
        Wenn das resoniert — dann bist du genau richtig hier.
      </motion.p>
    </div>
  </section>
);

export default Gatekeeper;